import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});

/**
 * Trek package details from Kirby used KirbyText (`kt()` → HTML).
 * Enquiries API returns the raw markdown/KirbyText source (e.g. `* bullet`).
 * Pass through real HTML; otherwise render as markdown.
 */
export function formatTrekDetails(raw?: string | null): string {
  const text = String(raw ?? "").trim();
  if (!text) return "";
  if (/<[a-z][\s\S]*>/i.test(text)) return text;
  try {
    return md.render(text);
  } catch {
    return text;
  }
}
